import React, { useEffect, useState } from 'react';
import api, { getApiBase, ficApi } from '../services/api';
import { postSicuro } from '../services/offline';

// ── Ordinamento colonne ─────────────────────────────────────
function sortData(data, col, dir) {
  return [...(data||[])].sort((a, b) => {
    let va = a[col] != null ? a[col] : '';
    let vb = b[col] != null ? b[col] : '';
    if (!isNaN(parseFloat(va)) && !isNaN(parseFloat(vb))) {
      va = parseFloat(va); vb = parseFloat(vb);
    } else { va = String(va).toLowerCase(); vb = String(vb).toLowerCase(); }
    return dir === 'asc' ? (va > vb ? 1 : va < vb ? -1 : 0) : (va < vb ? 1 : va > vb ? -1 : 0);
  });
}

function SortTh({ col, label, align, sortCol, sortDir, onSort }) {
  const active = sortCol === col;
  return (
    <th onClick={() => onSort(col)} style={{
      padding:'8px 10px', background:'#f1f5f9', borderBottom:'2px solid #e5e7eb',
      fontSize:11, fontWeight:600, whiteSpace:'nowrap', textAlign:align||'left',
      cursor:'pointer', userSelect:'none',
    }}>
      {label}{' '}<span style={{color:active?'#b30000':'#ccc',fontSize:10}}>
        {active ? (sortDir==='asc' ? '▲' : '▼') : '⇅'}
      </span>
    </th>
  );
}

function useSortState(defaultCol, defaultDir) {
  const [sortCol, setSortCol] = React.useState(defaultCol || 'date');
  const [sortDir, setSortDir] = React.useState(defaultDir || 'desc');
  const onSort = React.useCallback((col) => {
    setSortCol(prev => {
      if (prev === col) { setSortDir(d => d === 'asc' ? 'desc' : 'asc'); return prev; }
      setSortDir('desc');
      return col;
    });
  }, []);
  return { sortCol, sortDir, onSort };
}


const eur = n => '€ ' + parseFloat(n||0).toLocaleString('it-IT',{minimumFractionDigits:2});
const fmtData = d => d ? d.substring(0,10).split('-').reverse().join('/') : '—';



// ── Ordinamento colonne ────────────────────────────────────────
export default function DdtPage() {
  const [vista, setVista]  = useState('lista');
  const [ddtSel, setDdt]   = useState(null);

  if (vista==='nuovo')     return <NuovoDdt onBack={()=>setVista('lista')} onSaved={()=>setVista('lista')} />;
  if (vista==='dettaglio') return <DettaglioDdt ddt={ddtSel} onBack={()=>setVista('lista')} />;
  return <ListaDdt onNuovo={()=>setVista('nuovo')} onApri={d=>{setDdt(d);setVista('dettaglio');}} />;
}

// ── LISTA ──────────────────────────────────────────────────────
function ListaDdt({ onNuovo, onApri }) {
  const [ddt, setDdt]         = useState([]);
  const { sortCol, sortDir, onSort } = useSortState('date', 'desc');
  const ddtSorted = React.useMemo(() => sortData(ddt, sortCol, sortDir), [ddt, sortCol, sortDir]);
  const [loading, setLoading] = useState(true);
  const [pagina, setPagina]   = useState(1);
  const [totPagine, setTotPag]= useState(1);
  const [q, setQ]             = useState('');
  const [fatt, setFatt]       = useState({});   // ficDdtId -> true
  const [soloDaFatt, setSoloDaFatt] = useState(false);
  const [tecnici, setTecnici] = useState([]);
  const [assegn, setAssegn]   = useState({});   // ficDdtId -> tecnicoId

  const carica = async (p=1) => {
    setLoading(true);
    try {
      const res = await ficApi.ddt(p);
      setDdt(res.data?.data || []);
      setTotPag(res.data?.last_page || 1);
      setPagina(p);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  const caricaFatturati = async () => {
    try {
      const r = await api.get('/ddt-fatturazione');
      const m = {};
      (r.data?.data || []).forEach(x => { m[x.ficDdtId] = true; });
      setFatt(m);
    } catch (e) { console.error(e); }
  };

  const toggleFatt = async (ficId) => {
    const nuovo = !fatt[ficId];
    setFatt(f => ({ ...f, [ficId]: nuovo }));      // ottimistico
    try {
      await api.post(`/ddt-fatturazione/${ficId}`, { fatturato: nuovo });
    } catch (e) {
      setFatt(f => ({ ...f, [ficId]: !nuovo }));   // rollback
      alert(e?.response?.data?.error || 'Impossibile aggiornare lo stato.');
    }
  };

  const caricaAssegnazioni = async () => {
    try {
      const [ru, ra] = await Promise.all([
        api.get('/utenti').catch(()=>({data:{data:[]}})),
        api.get('/ddt-assegnazioni').catch(()=>({data:{data:[]}})),
      ]);
      const listaU = ru.data?.data || ru.data || [];
      setTecnici(listaU.filter(u => (u.ruolo||'').toLowerCase() === 'tecnico'));
      const m = {};
      (ra.data?.data || []).forEach(x => { m[x.ficDdtId] = x.tecnicoId; });
      setAssegn(m);
    } catch (e) { console.error(e); }
  };

  const assegnaTecnico = async (d, tecnicoId) => {
    const prec = assegn[d.id] ?? null;
    const val  = tecnicoId ? parseInt(tecnicoId, 10) : null;
    setAssegn(a => ({ ...a, [d.id]: val }));      // ottimistico
    try {
      await api.post(`/ddt-assegnazioni/${d.id}`, {
        tecnicoId: val,
        ddtNumero: String(d.number || d.numeration || ''),
        ddtData: d.date || null,
        clienteNome: d.entity?.name || null,
      });
    } catch (e) {
      setAssegn(a => ({ ...a, [d.id]: prec }));   // rollback
      alert(e?.response?.data?.error || 'Impossibile assegnare il DDT.');
    }
  };

  useEffect(() => { carica(1); caricaFatturati(); caricaAssegnazioni(); }, []);

  const filtrati = ddtSorted.filter(d =>
    (!q || d.entity?.name?.toLowerCase().includes(q.toLowerCase()) || String(d.number || d.numeration || '').includes(q))
    && (!soloDaFatt || !fatt[d.id])
  );

  return (
    <div className="page-content">
      <div style={{display:'flex',gap:12,marginBottom:16,flexWrap:'wrap'}}>
        <input className="form-control" style={{maxWidth:260}}
          placeholder="🔍 Cliente o numero..."
          value={q} onChange={e=>setQ(e.target.value)} />
        <button className="btn btn-primary" onClick={onNuovo}>➕ Nuovo DDT</button>
        <label style={{alignSelf:'center',fontSize:13,color:'#6b7280',cursor:'pointer'}}>
          <input type="checkbox" checked={soloDaFatt}
            onChange={e=>setSoloDaFatt(e.target.checked)} /> Solo da fatturare
        </label>
        <span style={{marginLeft:'auto',alignSelf:'center',color:'#9ca3af',fontSize:13}}>
          {filtrati.length} DDT · pag. {pagina}/{totPagine}
        </span>
      </div>

      {loading ? <div className="loading"><div className="spinner"></div></div> : (
        <div className="card" style={{padding:0}}>
          <div className="table-wrap">
            <table className="q-table">
              <thead><tr>
                <SortTh col='number' label='N°' align='left' sortCol={sortCol} sortDir={sortDir} onSort={onSort} /><SortTh col='date' label='Data' align='left' sortCol={sortCol} sortDir={sortDir} onSort={onSort} /><SortTh col='entity_name' label='Cliente' align='left' sortCol={sortCol} sortDir={sortDir} onSort={onSort} /><th>Causale</th>
                <th style={{padding:'8px 10px',background:'#f1f5f9',borderBottom:'2px solid #e5e7eb',fontSize:11,fontWeight:600,textAlign:'right'}}>Totale</th><th style={{padding:'8px 10px',background:'#f1f5f9',borderBottom:'2px solid #e5e7eb',fontSize:11,fontWeight:600,textAlign:'left'}}>Tecnico</th><th style={{padding:'8px 10px',background:'#f1f5f9',borderBottom:'2px solid #e5e7eb',fontSize:11,fontWeight:600,textAlign:'center'}}>Fatt.</th><th></th>
              </tr></thead>
              <tbody>
                {filtrati.length===0 && (
                  <tr><td colSpan={8} style={{textAlign:'center',color:'#9ca3af',padding:32}}>Nessun DDT</td></tr>
                )}
                {filtrati.map(d=>(
                  <tr key={d.id} style={{cursor:'pointer'}} onClick={()=>onApri(d)}>
                    <td><strong>{d.number || d.numeration || "—"}</strong></td>
                    <td style={{fontSize:12}}>{fmtData(d.date)}</td>
                    <td><strong>{d.entity?.name||'—'}</strong></td>
                    <td style={{fontSize:12,color:'#6b7280',maxWidth:200,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{d.subject || d.visible_subject || '—'}</td>
                    <td style={{textAlign:'right',fontWeight:600}}>{eur(d.amount_gross)}</td>
                    <td onClick={e=>e.stopPropagation()}>
                      <select value={assegn[d.id] || ''}
                        onChange={e=>assegnaTecnico(d, e.target.value)}
                        style={{fontSize:12,padding:'3px 6px',border:'1px solid #e5e7eb',
                                borderRadius:6,maxWidth:130,
                                color: assegn[d.id] ? '#111827' : '#9ca3af'}}>
                        <option value="">— non assegnato —</option>
                        {tecnici.map(t=>(
                          <option key={t.id} value={t.id}>{t.nome}</option>
                        ))}
                      </select>
                    </td>
                    <td style={{textAlign:'center'}} onClick={e=>e.stopPropagation()}>
                      <input type="checkbox" checked={!!fatt[d.id]}
                        onChange={()=>toggleFatt(d.id)}
                        title={fatt[d.id] ? 'Fatturato' : 'Non fatturato'}
                        style={{width:16,height:16,cursor:'pointer'}} />
                    </td>
                    <td style={{display:'flex',gap:4}} onClick={e=>e.stopPropagation()}>
                      {d.attachment_url &&
                        <a href={d.attachment_url} target="_blank" rel="noopener noreferrer"
                           className="btn btn-secondary btn-sm">🖨️ PDF</a>}
                      <button className="btn btn-secondary btn-sm" onClick={()=>onApri(d)}>Apri →</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {totPagine>1 && (
        <div style={{display:'flex',gap:8,marginTop:12,justifyContent:'center'}}>
          <button className="btn btn-secondary btn-sm" disabled={pagina<=1} onClick={()=>carica(pagina-1)}>⬅</button>
          <span style={{alignSelf:'center',fontSize:13}}>{pagina}/{totPagine}</span>
          <button className="btn btn-secondary btn-sm" disabled={pagina>=totPagine} onClick={()=>carica(pagina+1)}>➡</button>
        </div>
      )}
    </div>
  );
}

// ── DETTAGLIO ──────────────────────────────────────────────────
function DettaglioDdt({ ddt, onBack }) {
  const [dettaglio, setDettaglio] = React.useState(null);
  const [loading, setLoading]    = React.useState(true);
  const [statoFirma, setStatoFirma] = React.useState({ firmato:false });
  const [firmaOpen, setFirmaOpen] = React.useState(false);
  const [editOpen, setEditOpen]   = React.useState(false);
  const [eliminando, setEliminando] = React.useState(false);
  const [busy, setBusy]           = React.useState(false);

  const token = localStorage.getItem('quindi_token');

  const carica = React.useCallback(() => {
    setLoading(true);
    Promise.all([
      fetch(`${getApiBase()}/api/fic/ddt/${ddt.id}`, { headers:{'Authorization':'Bearer '+token} }).then(r=>r.json()).catch(()=>({})),
      fetch(`${getApiBase()}/api/ddt/${ddt.id}/stato-firma`, { headers:{'Authorization':'Bearer '+token} }).then(r=>r.json()).catch(()=>({firmato:false})),
    ]).then(([det, sf]) => {
      setDettaglio(det.data || ddt);
      setStatoFirma(sf || {firmato:false});
    }).finally(()=>setLoading(false));
  }, [ddt, token]);

  React.useEffect(() => { if (ddt) carica(); }, [ddt, carica]);

  const scaricaPdfFirmato = async () => {
    setBusy(true);
    try {
      const res = await fetch(`${getApiBase()}/api/ddt/${ddt.id}/pdf-firmato`, { headers:{'Authorization':'Bearer '+token} });
      if (!res.ok) throw new Error('Errore');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = `DDT_${dettaglio?.number||ddt.id}_firmato.pdf`;
      document.body.appendChild(a); a.click(); a.remove(); window.URL.revokeObjectURL(url);
    } catch(e){ alert('Errore nel download'); }
    finally { setBusy(false); }
  };

  const confermaFirma = async (firmaDataUrl, nomeFirm, firmaTecnico) => {
    setFirmaOpen(false); setBusy(true);
    const offline = !navigator.onLine;
    try {
      const esito = await postSicuro(`/ddt/${ddt.id}/firma`, {
        firma: firmaDataUrl || null,
        nome_firmatario: nomeFirm || null,
        firma_tecnico: firmaTecnico || null,
        firmata_il: new Date().toISOString().slice(0,19).replace('T',' '),
        firmata_offline: offline,
      });

      if (!esito.inviato) {
        if (esito.persa) {
          alert('ATTENZIONE: memoria del dispositivo piena, la firma NON e\' stata salvata. Libera spazio e ripeti.');
        } else {
          alert('Firma salvata sul dispositivo. Verra\' inviata al ritorno della rete.');
        }
        return;
      }

      // Online: il PDF si scarica a parte, l'endpoint di firma ora risponde JSON
      await scaricaPdfFirmato();
      carica();
    } catch(e){
      alert('Errore: ' + (e?.response?.data?.error || e.message));
    }
    finally { setBusy(false); }
  };

  if (!ddt) return null;
  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  const d2 = dettaglio || ddt;
  const firmato = statoFirma.firmato;
  return (
    <div className="page-content">
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16,flexWrap:'wrap'}}>
        <button className="btn btn-secondary" onClick={onBack}>⬅ DDT</button>
        <h2 style={{margin:0}}>DDT N° {d2.number || d2.numeration || '—'}</h2>
        {firmato
          ? <span className="badge badge-green">✍️ Firmato</span>
          : <span className="badge" style={{background:'#fef9c3',color:'#854d0e'}}>⏳ Da firmare</span>}
        <div style={{marginLeft:'auto',display:'flex',gap:6,flexWrap:'wrap'}}>
          {!firmato && (
            <button className="btn btn-secondary btn-sm" onClick={()=>setEditOpen(true)} disabled={busy}>✏️ Modifica</button>
          )}
          {!firmato && (
            <button className="btn btn-secondary btn-sm" disabled={busy||eliminando}
              style={{color:'#dc2626',borderColor:'#fecaca'}}
              onClick={async ()=>{
                if (!window.confirm('Eliminare definitivamente questo DDT?\n\nViene cancellato anche da Fatture in Cloud e il numero resta un buco nella sequenza.')) return;
                setEliminando(true);
                try {
                  const res = await fetch(`${getApiBase()}/api/ddt/${ddt.id}`, {
                    method:'DELETE', headers:{'Authorization':'Bearer '+token},
                  });
                  const j = await res.json().catch(()=>({}));
                  if (!res.ok) throw new Error(j.error||('Errore '+res.status));
                  onBack();
                } catch(e){ window.alert('Eliminazione non riuscita: '+e.message); }
                finally { setEliminando(false); }
              }}>{eliminando ? '...' : '🗑 Elimina'}</button>
          )}
          {!firmato && (
            <button className="btn btn-primary btn-sm" onClick={()=>setFirmaOpen(true)} disabled={busy}>✍️ Firma e genera PDF</button>
          )}
          {firmato && (
            <button className="btn btn-primary btn-sm" onClick={scaricaPdfFirmato} disabled={busy}>📄 Scarica PDF firmato</button>
          )}
          {d2.attachment_url && (
            <a href={d2.attachment_url} target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-sm">🖨️ PDF FIC</a>
          )}
        </div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,maxWidth:800}}>
        <div className="card">
          <div className="card-title" style={{marginBottom:12}}>📋 Dettagli</div>
          <table style={{width:'100%',fontSize:13}}>
            <tbody>
              {[
                ['Cliente', ddt.entity?.name || d2.entity?.name],
                ['Data',    fmtData(d2.date)],
                ['Causale', d2.subject || d2.visible_subject],
                ['Note',    d2.notes || d2.note],
              ].filter(([,v])=>v).map(([k,v])=>(
                <tr key={k}><td style={{color:'#9ca3af',padding:'4px 0',width:'35%'}}>{k}</td><td>{v}</td></tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="card">
          <div className="card-title" style={{marginBottom:12}}>💰 Importo</div>
          <div style={{fontSize:28,fontWeight:700,color:'#b30000'}}>{eur(d2.amount_gross)}</div>
          <div style={{fontSize:12,color:'#9ca3af',marginTop:4}}>Totale lordo</div>
        </div>

        {(d2.items_list?.length > 0 || false) && (
          <div className="card" style={{gridColumn:'1/-1',padding:0}}>
            <div style={{padding:'12px 16px',fontWeight:600,fontSize:13,borderBottom:'1px solid #e5e7eb'}}>📦 Articoli</div>
            <div className="table-wrap">
              <table className="q-table">
                <thead><tr>
                  <th>Descrizione</th>
                  <th style={{textAlign:'center'}}>Qtà</th>
                  <th style={{textAlign:'right'}}>Prezzo</th>
                  <th style={{padding:'8px 10px',background:'#f1f5f9',borderBottom:'2px solid #e5e7eb',fontSize:11,fontWeight:600,textAlign:'right'}}>Totale</th>
                </tr></thead>
                <tbody>
                  {(d2.items_list||[]).map((item,i)=>(
                    <tr key={i}>
                      <td>{item.name}{item.description ? (item.name ? ' — ' : '') + item.description : ''}</td>
                      <td style={{textAlign:'center'}}>{item.qty}</td>
                      <td style={{textAlign:'right'}}>{eur(item.net_price)}</td>
                      <td style={{textAlign:'right',fontWeight:600}}>{eur(parseFloat(item.qty||1)*parseFloat(item.net_price||0))}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {firmaOpen && <FirmaDdtModalSeparato onClose={()=>setFirmaOpen(false)} onConfirm={confermaFirma} />}
      {editOpen && <ModificaDdtModal ddtId={ddt.id} dettaglio={d2} token={token}
        onClose={()=>setEditOpen(false)} onSaved={()=>{setEditOpen(false); carica();}} />}
    </div>
  );
}

// ── MODALE MODIFICA DDT (righe + causale) ─────────────────────
function ModificaDdtModal({ ddtId, dettaglio, token, onClose, onSaved }) {
  const [subject, setSubject] = React.useState(dettaglio.subject || '');
  const [righe, setRighe] = React.useState(
    (dettaglio.items_list||[]).map(it => ({
      descrizione: it.name || '',
      descrizione_estesa: it.description || '',
      prodotto_id: it.product_id || null,
      quantita: it.qty||1, prezzo: it.net_price||0, iva: it.vat?.value||22, sconto: 0,
    }))
  );
  const [prodotti, setProdotti] = React.useState([]);
  const [cercaP, setCercaP]     = React.useState('');
  const [rigaAtt, setRigaAtt]   = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const [err, setErr] = React.useState('');

  React.useEffect(() => {
    api.get('/preventivi/prodotti').then(r => setProdotti(r.data?.data || [])).catch(console.error);
  }, []);

  const setR = (i,k,v) => setRighe(rr => rr.map((r,idx)=> idx===i ? {...r,[k]:v} : r));
  const addR = () => setRighe(rr => [...rr, {descrizione:'',descrizione_estesa:'',prodotto_id:null,quantita:1,prezzo:0,iva:22,sconto:0}]);
  const delR = (i) => setRighe(rr => rr.filter((_,idx)=>idx!==i));

  const prodottiFiltrati = prodotti.filter(p => !cercaP ||
    p.name?.toLowerCase().includes(cercaP.toLowerCase()) ||
    (p.code||'').toLowerCase().includes(cercaP.toLowerCase()));

  const applicaProdotto = (i, prod) => {
    setRighe(rr => rr.map((r,idx)=> idx===i ? {
      ...r, descrizione: prod.name, prodotto_id: prod.id,
      prezzo: parseFloat(prod.net_price||0), iva: prod.vat?.value || 22,
    } : r));
    setCercaP(''); setRigaAtt(null);
  };

  const salva = async () => {
    setSaving(true); setErr('');
    try {
      const utili = righe.filter(r =>
        (r.descrizione||'').trim() || (r.descrizione_estesa||'').trim());
      const res = await fetch(`${getApiBase()}/api/ddt/${ddtId}/modifica`, {
        method:'PUT', headers:{'Authorization':'Bearer '+token,'Content-Type':'application/json'},
        body: JSON.stringify({ subject, righe: utili }),
      });
      if (!res.ok) { const j = await res.json().catch(()=>({})); throw new Error(j.error||'Errore'); }
      onSaved();
    } catch(e){ setErr(e.message); }
    finally { setSaving(false); }
  };

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000,padding:20}} onClick={onClose}>
      <div style={{background:'#fff',borderRadius:12,padding:24,width:'100%',maxWidth:760,maxHeight:'90vh',overflowY:'auto'}} onClick={e=>e.stopPropagation()}>
        <h3 style={{margin:'0 0 16px',fontSize:16}}>Modifica DDT</h3>
        <label className="form-label">Causale</label>
        <input className="form-control" value={subject} onChange={e=>setSubject(e.target.value)} style={{marginBottom:16}} />

        <label className="form-label">Righe materiali</label>
        <div style={{fontSize:11,color:'#6b7280',marginBottom:8}}>
          Lascia vuoto l'articolo e compila solo la nota per una riga descrittiva.
        </div>

        {righe.map((r,i)=>(
          <div key={i} style={{border:'1px solid #e5e7eb',borderRadius:8,padding:8,marginBottom:8}}>
            <div style={{display:'flex',gap:6,alignItems:'center'}}>
              <input className="form-control" placeholder="Articolo" value={r.descrizione}
                     onChange={e=>setR(i,'descrizione',e.target.value)} style={{flex:3}} />
              <button onClick={()=>{ setRigaAtt(rigaAtt===i?null:i); setCercaP(''); }}
                      title="Cerca a listino"
                      style={{border:'none',background:'#e0e7ff',color:'#3730a3',borderRadius:5,padding:'6px 9px',cursor:'pointer'}}>&#128269;</button>
              <input className="form-control" type="number" placeholder="Q.ta" value={r.quantita}
                     onChange={e=>setR(i,'quantita',e.target.value)} style={{flex:1}} />
              <input className="form-control" type="number" placeholder="Prezzo" value={r.prezzo}
                     onChange={e=>setR(i,'prezzo',e.target.value)} style={{flex:1}} />
              <button onClick={()=>delR(i)} style={{border:'none',background:'#fee2e2',color:'#dc2626',borderRadius:5,padding:'6px 9px',cursor:'pointer'}}>&#128465;</button>
            </div>

            <input className="form-control" placeholder="Nota / descrizione estesa"
                   value={r.descrizione_estesa}
                   onChange={e=>setR(i,'descrizione_estesa',e.target.value)}
                   style={{marginTop:6,fontSize:12}} />

            {r.prodotto_id && (
              <div style={{fontSize:10,color:'#059669',marginTop:4}}>collegato a magazzino (id {r.prodotto_id})</div>
            )}

            {rigaAtt===i && (
              <div style={{marginTop:6,border:'1px solid #c7d2fe',borderRadius:6,padding:6,background:'#f8faff'}}>
                <input className="form-control" autoFocus placeholder="Cerca articolo o codice..."
                       value={cercaP} onChange={e=>setCercaP(e.target.value)} style={{fontSize:12}} />
                <div style={{maxHeight:170,overflowY:'auto',marginTop:6}}>
                  {prodottiFiltrati.slice(0,40).map(pr=>(
                    <div key={pr.id} onClick={()=>applicaProdotto(i,pr)}
                         style={{padding:'5px 7px',cursor:'pointer',fontSize:12,borderBottom:'1px solid #eef2ff',display:'flex',gap:8}}>
                      <code style={{color:'#6b7280',minWidth:60}}>{pr.code||'-'}</code>
                      <span style={{flex:1}}>{pr.name}</span>
                      <span style={{color:'#6b7280'}}>{eur(pr.net_price)}</span>
                    </div>
                  ))}
                  {!prodottiFiltrati.length && <div style={{padding:6,fontSize:12,color:'#9ca3af'}}>Nessun articolo</div>}
                </div>
              </div>
            )}
          </div>
        ))}

        <button className="btn btn-secondary btn-sm" onClick={addR} style={{marginTop:4}}>+ Riga</button>
        {err && <div style={{color:'#dc2626',fontSize:12,marginTop:10}}>{err}</div>}
        <div style={{display:'flex',gap:8,marginTop:20}}>
          <button className="btn btn-secondary" style={{flex:1}} onClick={onClose}>Annulla</button>
          <button className="btn btn-primary" style={{flex:1}} onClick={salva} disabled={saving}>{saving?'...':'Salva modifiche'}</button>
        </div>
      </div>
    </div>
  );
}

// ── NUOVO DDT ──────────────────────────────────────────────────
function NuovoDdt({ onBack, onSaved }) {
  const [clienti, setClienti]   = useState([]);
  const [prodotti, setProdotti] = useState([]);
  const [cercaC, setCercaC]     = useState('');
  const [clienteSel, setClSel] = useState(null);
  const [form, setForm]         = useState({
    data:    new Date().toISOString().split('T')[0],
    oggetto: '',
    note:    '',
  });
  const [righe, setRighe]   = useState([{descrizione:'',quantita:1,prezzo:0,iva:22,sconto:0}]);
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');
  const [cercaP, setCercaP] = useState('');

  useEffect(() => {
    api.get('/preventivi/clienti').then(r => setClienti(r.data?.data || [])).catch(console.error);
    api.get('/preventivi/prodotti').then(r => setProdotti(r.data?.data || [])).catch(console.error);
  }, []);

  const clientiFiltrati = clienti.filter(c => !cercaC || c.name?.toLowerCase().includes(cercaC.toLowerCase()));
  const prodottiFiltrati = prodotti.filter(p => !cercaP || p.name?.toLowerCase().includes(cercaP.toLowerCase()) || (p.code||'').toLowerCase().includes(cercaP.toLowerCase()));

  const aggRiga  = () => setRighe(r => [...r, {descrizione:'',quantita:1,prezzo:0,iva:22,sconto:0}]);
  const rimuRiga = i  => setRighe(r => r.filter((_,j) => j!==i));
  const setRiga  = (i,k,v) => setRighe(r => r.map((x,j) => j===i ? {...x,[k]:v} : x));

  const applicaProdotto = (i, prod) => {
    setRiga(i,'descrizione', prod.name);
    setRiga(i,'prodotto_id', prod.id);
    setRiga(i,'prezzo',      parseFloat(prod.net_price||0));
    setRiga(i,'iva',         prod.vat?.value || 22);
    setCercaP('');
  };

  const totImponibile = righe.reduce((s,r) => { const b=parseFloat(r.quantita||1)*parseFloat(r.prezzo||0); return s+b-b*parseFloat(r.sconto||0)/100; }, 0);
  const totIva        = righe.reduce((s,r) => { const b=parseFloat(r.quantita||1)*parseFloat(r.prezzo||0); const imp=b-b*parseFloat(r.sconto||0)/100; return s+imp*parseFloat(r.iva||22)/100; }, 0);

  const salva = async () => {
    if (!clienteSel) { setError('Seleziona un cliente.'); return; }
    if (righe.filter(r => r.descrizione.trim()).length === 0) { setError('Aggiungi almeno una riga.'); return; }
    setSaving(true); setError('');
    try {
      await api.post('/ddt', {
        cliente_fic_id:     clienteSel.id,
        cliente_nome:       clienteSel.name,
        cliente_indirizzo:  clienteSel.address_street || clienteSel.address || '',
        cliente_cap:        clienteSel.address_postal_code || '',
        cliente_citta:      clienteSel.address_city || '',
        data:               form.data,
        oggetto:            form.oggetto,
        note:               form.note,
        righe:              righe.filter(r => r.descrizione.trim()),
      });
      onSaved();
    } catch(e) {
      setError(e.response?.data?.error || 'Errore nel salvataggio su FIC.');
    } finally { setSaving(false); }
  };

  return (
    <div className="page-content">
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16}}>
        <button className="btn btn-secondary" onClick={onBack}>⬅ Indietro</button>
        <h2 style={{margin:0}}>➕ Nuovo DDT</h2>
      </div>

      {error && <div className="error-msg" style={{marginBottom:16}}>{error}</div>}

      <div style={{maxWidth:900}}>
        {/* CLIENTE */}
        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:12}}>👥 Cliente</div>
          {clienteSel ? (
            <div style={{display:'flex',alignItems:'center',gap:12}}>
              <strong style={{flex:1}}>{clienteSel.name}</strong>
              <button className="btn btn-secondary btn-sm" onClick={()=>{setClSel(null);setCercaC('');}}>✕ Cambia</button>
            </div>
          ) : (
            <div>
              <input className="form-control" placeholder="Cerca cliente FIC..."
                value={cercaC} onChange={e=>setCercaC(e.target.value)} style={{marginBottom:8}} />
              {cercaC && (
                <div style={{border:'1px solid #e5e7eb',borderRadius:6,maxHeight:200,overflowY:'auto',background:'#fff'}}>
                  {clientiFiltrati.slice(0,15).map(c=>(
                    <div key={c.id} onClick={()=>{setClSel(c);setCercaC(c.name);}}
                      style={{padding:'8px 12px',cursor:'pointer',borderBottom:'1px solid #f3f4f6',fontSize:13}}
                      onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
                      onMouseLeave={e=>e.currentTarget.style.background=''}>
                      <strong>{c.name}</strong>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        {/* DATI */}
        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:12}}>📋 Dati DDT</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Data</label>
              <input type="date" className="form-control" value={form.data}
                onChange={e=>setForm(f=>({...f,data:e.target.value}))} />
            </div>
            <div className="form-group" style={{margin:0}}>
              <label className="form-label">Causale</label>
              <input className="form-control" value={form.oggetto}
                onChange={e=>setForm(f=>({...f,oggetto:e.target.value}))}
                placeholder="Es. Sostituzione materiali antincendio..." />
            </div>
          </div>
        </div>

        {/* RIGHE */}
        <div className="card" style={{marginBottom:16}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
            <span className="card-title">📦 Articoli</span>
            <button className="btn btn-secondary btn-sm" onClick={aggRiga}>➕ Riga</button>
          </div>

          <input className="form-control" placeholder="🔍 Cerca nel catalogo FIC..."
            value={cercaP} onChange={e=>setCercaP(e.target.value)} style={{marginBottom:6}} />
          {cercaP && (
            <div style={{border:'1px solid #e5e7eb',borderRadius:6,maxHeight:150,overflowY:'auto',marginBottom:8,background:'#fff',fontSize:12}}>
              {prodottiFiltrati.slice(0,10).map(p=>(
                <div key={p.id} style={{padding:'6px 12px',cursor:'pointer',borderBottom:'1px solid #f3f4f6',display:'flex',gap:8}}
                  onMouseEnter={e=>e.currentTarget.style.background='#f9fafb'}
                  onMouseLeave={e=>e.currentTarget.style.background=''}
                  onClick={()=>applicaProdotto(righe.length-1,p)}>
                  <span style={{flex:1}}>{p.name}</span>
                  <span style={{color:'#6b7280'}}>€{parseFloat(p.net_price||0).toFixed(2)}</span>
                </div>
              ))}
            </div>
          )}

          <table style={{width:'100%',borderCollapse:'collapse',fontSize:13}}>
            <thead><tr style={{background:'#f9fafb'}}>
              <th style={{padding:'6px',textAlign:'left'}}>Descrizione</th>
              <th style={{padding:'6px',textAlign:'center',width:60}}>Qtà</th>
              <th style={{padding:'6px',textAlign:'right',width:90}}>Prezzo</th>
              <th style={{padding:'6px',textAlign:'center',width:55}}>IVA%</th>
              <th style={{padding:'6px',textAlign:'right',width:90}}>Totale</th>
              <th style={{width:32}}></th>
            </tr></thead>
            <tbody>
              {righe.map((r,i)=>{
                const b=parseFloat(r.quantita||1)*parseFloat(r.prezzo||0);
                const tot=b-b*parseFloat(r.sconto||0)/100;
                return (
                  <tr key={i}>
                    <td style={{padding:'3px'}}><input className="form-control" value={r.descrizione} onChange={e=>setRiga(i,'descrizione',e.target.value)} style={{fontSize:12,padding:'4px 6px'}} /></td>
                    <td style={{padding:'3px'}}><input type="number" className="form-control" value={r.quantita} min={1} onChange={e=>setRiga(i,'quantita',e.target.value)} style={{fontSize:12,padding:'4px 6px',textAlign:'center'}} /></td>
                    <td style={{padding:'3px'}}><input type="number" className="form-control" value={r.prezzo} min={0} step={0.01} onChange={e=>setRiga(i,'prezzo',e.target.value)} style={{fontSize:12,padding:'4px 6px',textAlign:'right'}} /></td>
                    <td style={{padding:'3px'}}><input type="number" className="form-control" value={r.iva} min={0} onChange={e=>setRiga(i,'iva',e.target.value)} style={{fontSize:12,padding:'4px 6px',textAlign:'center'}} /></td>
                    <td style={{padding:'3px',textAlign:'right',fontWeight:600,fontSize:12}}>{eur(tot)}</td>
                    <td style={{padding:'3px'}}><button className="btn btn-danger btn-sm" onClick={()=>rimuRiga(i)}>✕</button></td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr><td colSpan={4} style={{padding:'8px 6px',textAlign:'right',color:'#6b7280',fontSize:13}}>Imponibile:</td><td style={{padding:'8px 6px',textAlign:'right',fontWeight:600}}>{eur(totImponibile)}</td><td></td></tr>
              <tr><td colSpan={4} style={{padding:'3px 6px',textAlign:'right',color:'#6b7280',fontSize:13}}>IVA:</td><td style={{padding:'3px 6px',textAlign:'right',fontWeight:600}}>{eur(totIva)}</td><td></td></tr>
              <tr><td colSpan={4} style={{padding:'8px 6px',textAlign:'right',fontWeight:700,borderTop:'2px solid #e5e7eb'}}>Totale:</td><td style={{padding:'8px 6px',textAlign:'right',fontWeight:700,color:'#b30000',fontSize:15,borderTop:'2px solid #e5e7eb'}}>{eur(totImponibile+totIva)}</td><td></td></tr>
            </tfoot>
          </table>
        </div>

        <div className="card" style={{marginBottom:16}}>
          <div className="card-title" style={{marginBottom:8}}>📝 Note</div>
          <textarea className="form-control" rows={2} value={form.note}
            onChange={e=>setForm(f=>({...f,note:e.target.value}))} placeholder="Note aggiuntive..." />
        </div>

        <div style={{display:'flex',gap:8}}>
          <button className="btn btn-primary" onClick={salva} disabled={saving}>
            {saving?'Salvataggio...':'💾 Crea DDT'}
          </button>
          <button className="btn btn-secondary" onClick={onBack}>Annulla</button>
        </div>
      </div>
    </div>
  );
}

// ── MODALE FIRMA DDT SEPARATO ─────────────────────────────────
function useCanvasFirma() {
  const ref = React.useRef(null);
  const [vuoto, setVuoto] = React.useState(true);
  React.useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    canvas.width = canvas.offsetWidth;
    canvas.height = 160;
    const ctx = canvas.getContext('2d');
    ctx.strokeStyle = '#1e293b'; ctx.lineWidth = 2; ctx.lineCap = 'round';
    let disegna = false;
    const pos = e => {
      const r = canvas.getBoundingClientRect();
      const t = e.touches ? e.touches[0] : e;
      return { x: t.clientX - r.left, y: t.clientY - r.top };
    };
    const start = e => { e.preventDefault(); disegna = true; const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); };
    const draw  = e => { if (!disegna) return; e.preventDefault(); const p = pos(e); ctx.lineTo(p.x, p.y); ctx.stroke(); setVuoto(false); };
    const stop  = () => { disegna = false; };
    canvas.addEventListener('mousedown', start);
    canvas.addEventListener('mousemove', draw);
    canvas.addEventListener('mouseup', stop);
    canvas.addEventListener('touchstart', start, {passive:false});
    canvas.addEventListener('touchmove', draw, {passive:false});
    canvas.addEventListener('touchend', stop);
    return () => {
      canvas.removeEventListener('mousedown', start);
      canvas.removeEventListener('mousemove', draw);
      canvas.removeEventListener('mouseup', stop);
      canvas.removeEventListener('touchstart', start);
      canvas.removeEventListener('touchmove', draw);
      canvas.removeEventListener('touchend', stop);
    };
  }, []);
  const pulisci = () => {
    const c = ref.current;
    if (!c) return;
    c.getContext('2d').clearRect(0, 0, c.width, c.height);
    setVuoto(true);
  };
  const dataUrl = () => (vuoto || !ref.current) ? null : ref.current.toDataURL('image/png');
  return { ref, vuoto, pulisci, dataUrl };
}

function RiquadroFirma({ titolo, canvas }) {
  return (
    <div style={{marginBottom:12}}>
      <div style={{display:'flex',alignItems:'center',marginBottom:4}}>
        <label className="form-label" style={{margin:0}}>{titolo}</label>
        <div style={{flex:1}} />
        <button className="btn btn-secondary btn-sm" onClick={canvas.pulisci}>🗑 Cancella</button>
      </div>
      <canvas ref={canvas.ref}
        style={{width:'100%',height:160,border:'2px dashed #cbd5e1',borderRadius:8,
                touchAction:'none',background:'#fafafa',cursor:'crosshair'}} />
    </div>
  );
}

export function FirmaDdtModalSeparato({ onClose, onConfirm }) {
  const cliente = useCanvasFirma();
  const [nomeFirmatario, setNome] = React.useState('');
  const offline = !navigator.onLine;

  const conferma = () => onConfirm(
    cliente.dataUrl(),
    nomeFirmatario.trim(),
    null
  );

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000,padding:20}}
      onClick={onClose}>
      <div style={{background:'#fff',borderRadius:12,padding:24,width:'100%',maxWidth:520,maxHeight:'90vh',overflowY:'auto'}}
        onClick={e=>e.stopPropagation()}>
        <h3 style={{margin:'0 0 4px',fontSize:16}}>✍️ Firma di consegna</h3>
        <p style={{margin:'0 0 12px',fontSize:13,color:'#6b7280'}}>
          Firma del cliente che ritira la merce.
        </p>

        {offline && (
          <div style={{background:'#fef9c3',color:'#854d0e',padding:'8px 12px',borderRadius:8,
                       fontSize:12,marginBottom:12}}>
            📵 Sei offline: le firme restano sul dispositivo e verranno inviate al ritorno della rete.
          </div>
        )}

        <div style={{marginBottom:12}}>
          <label className="form-label">Nome e cognome di chi ritira *</label>
          <input className="form-control" value={nomeFirmatario}
            onChange={e=>setNome(e.target.value)}
            placeholder="Es. Mario Rossi" />
        </div>

        <RiquadroFirma titolo="Firma del cliente" canvas={cliente} />

        <div style={{display:'flex',gap:8,marginTop:16}}>
          <div style={{flex:1}} />
          <button className="btn btn-secondary" onClick={onClose}>Annulla</button>
          <button className="btn btn-primary" onClick={conferma}
            disabled={!nomeFirmatario.trim()}>✅ Conferma</button>
        </div>
        <p style={{margin:'10px 0 0',fontSize:11,color:'#9ca3af',textAlign:'center'}}>
          Il nome di chi ritira è obbligatorio. La firma grafica è facoltativa.
        </p>
      </div>
    </div>
  );
}
